// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AccordionSidePane_wrapper__mjviO","trigger":"AccordionSidePane_trigger__oWzD0","icon":"AccordionSidePane_icon__RVw1v"};